import PortfolioCard from './PortfolioCard'
import useElementNames from 'hooks/useElementNames'
import pluralize from 'pluralize'
import { Card } from 'react-bootstrap'
import Slider from 'react-slick'

const slidesToShow = 3

const Portfolios = ({ department, isMonthly, setSelectedPortfolio, selectedPortfolio }) => {
  const portfolios = department.portfolios || []
  const elementNames = useElementNames()

  const settings = {
    ...(portfolios.length < slidesToShow && { className: 'slick-align-left' }),
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1
  }
  return (
    <Card className="departments section-gray mb-3">
      <Card.Body>
        <h3 className="text-uppercase">{pluralize(elementNames.element3)}</h3>
        {portfolios.length > 0 ? (
          <Slider {...settings}>
            {portfolios.map((portfolio, i) => (
              <PortfolioCard
                key={`portfolio-card-${i}`}
                departmentName={department.name}
                portfolio={portfolio}
                isMonthly={isMonthly}
                setSelectedPortfolio={setSelectedPortfolio}
                selectedPortfolio={selectedPortfolio}
              />
            ))}
          </Slider>
        ) : (
          <div className="alert alert-info">There is not any portfolio for this department</div>
        )}
      </Card.Body>
    </Card>
  )
}
export default Portfolios
